import {gql} from '@apollo/client';

export const reminderMutations = {
    CREATE_REMINDER: gql`
        mutation CreateReminder($input: ReminderCreateRequestModelInput!) {
            createReminder(input: $input) {
                description
                id
                objectId
                objectType
                reminderDate
                status
                title
                type
                userId
            }
        }
    `,
    UPDATE_REMINDER: gql`
        mutation UpdateReminder($input: ReminderUpdateRequestModelInput!) {
            updateReminder(input: $input) {
                description
                id
                objectId
                objectType
                reminderDate
                status
                title
                type
                userId
            }
        }
    `,
    REMOVE_REMINDERS_BY_IDS: gql`
        mutation RemoveRemindersByIds($reminderIds: [UUID!]!) {
            removeRemindersByIds(reminderIds: $reminderIds) {
                statusCode
                message
                data
            }
        }
    `,
    REMOVE_REMINDERS_BY_USER_ID: gql`
        mutation RemoveRemindersByUserId($userId: UUID!) {
            removeRemindersByUserId(userId: $userId) {
                statusCode
                message
                data
            }
        }
    `,
};
